<!-- constants -->
window.AdultCategories = [
  'anansi-books',
  'bestselling',
  'starred-review-titles',
  'new-releases',
  'coming-soon',
  'award-winning',
  'imprint-a-list',
  'the-massey-lectures',
  "munk-debates",
  "audiobooks",
  "special-editions",
  "book-club-picks",
  "literary-fiction",
  "thrillers-mystery",
  "nonfiction-titles",
  "cookbooks",
  "humor",
  "poetry",
  "short-story-collections",
  "bipoc-voices",
  "technology-politics",
  "feminist-reads",
  "environmentalism",
  "lgbtq-stories",
  "backlist-adult-poetry",
  "massey-lectures-sale",
  "adult-course-adoption",
  "indigenous-voices-1",
  "celebrate-pride",
  "griffin-poetry-prize-anthology",
  "anansi-new-releases-may-3-2022",
  "walrus-books-very-good-nonfiction",
  "2022-poetry-collections",
  "very-good-gifts",
  "linkedin",
  "august-new-releases",
  "verygoodgifts",
  "55",
  "wintery-anansi-reads",
  "debut-authors",
  "debut-non-fiction",
  "chidiogo-akunyili-parrs-recommended-reads-for-black-history-month-2023",
  "poetry-bash-2023",
  "course-catalogue",
  "governor-generals-literary-awards-winners",
  "for-book-clubs",
  "books-for-dad",
  "for-your-analog-bag"
]

<!-- end of constants -->


function orderByType(submenu) {
//  if (submenu) return // already should have all the items sorted 

  const order = [
   'board',
   'hardcover',
   'paperback'
  ]

  if (submenu) {
    submenu = submenu[0].classList.contains('nav-dropdown-custom') 
    ? submenu[0]
    : submenu[0].querySelector('.nav-dropdown-custom')
  }

  let arr = submenu 
    ? submenu.querySelectorAll('li') 
    : document.querySelectorAll('#product-info .nav-dropdown-custom li')

  let topOrdered = Array.from(arr)
    .filter(({dataset}) =>
      dataset.title && order.some(t => dataset.title.toLowerCase().includes(t))
    )

  let rest = Array.from(arr)
    .filter(({dataset}) =>
      dataset.title && order.every(t => !dataset.title.toLowerCase().includes(t))
    )

  let sorted = topOrdered.sort((el1, el2) => {
      if (el1.dataset.title.toLowerCase().includes('board'))
        return -1

      if (el1.dataset.title.toLowerCase().includes('hardcover'))
        return 0

      if (el1.dataset.title.toLowerCase().includes('paperback'))
        return 1
    }
  )

  let elems = [...sorted, ...rest]

  return submenu 
    ? $(submenu).html(elems) 
    : $('.nav-dropdown-custom').append(elems)

}

function selectFirst(submenu) {
  let first = submenu 
    ? submenu.find('li')[0]
    : $('.nav-dropdown-custom li')[0]
  handleDropdownClick.call(first)
}

function toggleActive() {
  let dropdown = this.parentNode.querySelector('.nav-dropdown-custom')
  let expanded = this.getAttribute('aria-expanded')

  this.setAttribute('aria-expanded', expanded == 'false')

  dropdown.classList.contains('active')
    ? dropdown.classList.remove('active')
    : dropdown.classList.add('active')
}

function handleOutsideClick(context) {
  return e => {
    let parentSelectors = $(e.target).parents('.dropdown-variant-select')
    if (parentSelectors.length) return 

    closeIfOpen(context)
  }
}

function closeIfOpen(context) {
  let dropdown = context.find('.nav-dropdown-custom.active')
  if (dropdown.length) { 
    let activeVariant = context.find('.active-variant')
    toggleActive.call(activeVariant[0])
  }
}

function toggleSpecifications(title) {
  $('.specifications').each(function(i, el) {
    el.dataset.title.toLowerCase() == title.toLowerCase()
    ? $(el).removeClass('hidden')
    : $(el).addClass('hidden')
  })

  let row = $('.specifications-row')
  if (!row) return 

  let specification = row.find('.specifications:not(.hidden)')
  if (!specification) return row.hide()
  
  specification.text().trim()  
    ? row.show()
    : row.hide()
} 

function togglePubDate(title){
  $('.pubDate').each(function(i, el) {
    el.dataset.title.toLowerCase() == title.toLowerCase()
    ? $(el).removeClass('hidden')
    : $(el).addClass('hidden')
  })

  let row = $('.pubDate-row')
  if (!row) return 

  let pubDate = row.find('.pubDate:not(.hidden)')
  if (!pubDate) return row.hide()
  
  pubDate.text().trim()  
    ? row.show()
    : row.hide()  
}

function handleDropdownClick() {
  let parent = $(this).parents('.dropdown-variant-select')

  let price = this.dataset.price
  let product = this.dataset.product
  let title = this.dataset.title
  let barcode = this.dataset.barcode
  let id = this.dataset.id
  let available = this.dataset.available
  let pubDate = this.dataset.publicationdate

  parent.find('#variant-code-select').text(barcode)
  parent.find('#variant-price-select').text(price)
  parent.find('#selected-title').text(title)

  // Toggle specifications
  if (parent.parents('.page-product.product-single')) {
    toggleSpecifications(title)
    togglePubDate(title)
  }

  $('#add-to-cart-form input[name="quantity"]').prop('value', 1)
  $('#add-to-cart-form input[name="id"]').prop('value', id)

  maybeToggleAddToCart(title, parent, product, available == 'true', pubDate)
  hideDropdown()
}

function hideRetailersNote() {
  let note = document.querySelector('.retailers-note')
  if (note) note.classList.add("hidden")
}

function showRetailersNote() {
  let note = document.querySelector('.retailers-note')
  if (note) note.classList.remove("hidden")
}

function hidePreorderNote() {
  let note = document.querySelector('.preorder-note')
  if (note) note.classList.add("hidden")
}

function showPreorderNote() {
  let note = document.querySelector('.preorder-note')
  if (note) note.classList.remove("hidden")
}

function hideComingSoonNote(context = document) {
  let note = context.querySelector('.coming-soon-note')
  if (note) note.classList.add("hidden")
}

function showComingSoonNote(context = document) {
  let note = context.querySelector('.coming-soon-note')
  if (note) note.classList.remove("hidden")
}

function maybeToggleAddToCart(title, context = document, product = '', available, pubDate) {

  if (context instanceof $) {
    context = 
      context.parents('#add-to-cart-form')[0] 
      || context.parents('#qs-product-action')[0]
  }

  context = context || document

  let btn = context.querySelector('#add-to-cart') 
    || context.querySelector('#qs-add-cart')
  let notes = context.querySelectorAll('.book-note')

  const actualPubDate = pubDate || '1990-01-01'
  const targetDate = new Date(actualPubDate)
  const now = new Date()
  const isPubbed = targetDate.getTime() < now.getTime()

  let selectedVariant = context.querySelector('#variant-code-select')
  let isbn = selectedVariant && selectedVariant.textContent

  let audio = /audio/gi
  let isAudio = audio.test(title)

  let physical = /paperback|^hardcover|^hardcover\sjacket|board\sbook|^board\sgame|^jigsaw/gi.test(title)
  let mp3 = /mp3/gi
  let isMP3 = mp3.test(title)
  let isEpub = /epub/gi.test(title)
  let isKindle = /(Kindle)|(mobi)/gi.test(title)
  let isWebPDF = /Web\sPDF/gi.test(title)
  let unavailableDigital = /(digital\sbraille)|(iBooks)|(WAV)/gi.test(title)

  let isDigital = isEpub || isKindle || isWebPDF || unavailableDigital || isMP3
  if (!isDigital) {
    btn.disabled = false
    btn.hidden = false
  }

  
  if (!isPubbed) { 
    showPreorderNote()
    physical ? showComingSoonNote(context) : hideComingSoonNote(context);
    context.querySelector('.product-action-buttons button').style.cursor = 'default'
  } else {
    physical ? hideRetailersNote() : showRetailersNote();
    hidePreorderNote()
    hideComingSoonNote(context)
  }

  notes.forEach(note => note.classList.add('hidden'))

  if (!available || !isPubbed) {
    btn.disabled = true
    if (!available) {
      let note = context.querySelector('#out-of-stock-note')
      note.classList.remove('hidden')
    }
  }

  if (isEpub) {
    buildRetailerLinks(isbn, 'epubs', product)
    let note = context.querySelector('#digital-note')
    note.classList.remove('hidden')
    btn.hidden = true
    btn.disabled = true
    return
  }

  if (isKindle) {
    // only amazon
    buildRetailerLinks(isbn, 'amazon-only', product)
    let note = context.querySelector('#digital-note')
    note.classList.remove('hidden')
    btn.hidden = true
    btn.disabled = true
    return
  }

  if (isWebPDF) {
    // only google play
    buildRetailerLinks(isbn, 'web-pdf')
    let note = context.querySelector('#digital-note')
    note.classList.remove('hidden')
    btn.hidden = true
    btn.disabled = true
    return
  }

  if (unavailableDigital) {
    // unavailable
    btn.disabled = true
    btn.hidden = true
    hideRetailersNote()
    return
  }

  if (isMP3) {
    buildRetailerLinks(isbn, 'audio', product)
    let note = context.querySelector('#audio-note')
    note.classList.remove('hidden')
    btn.hidden = true
    btn.disabled = true
    return
  } 

  if (physical) {
    let note = context.querySelector('#retailer-links')
    note && note.classList.remove('hidden')
    return buildRetailerLinks(isbn, '', product)
  }
}

const populateLinks = links => {
  document.querySelectorAll('.book-note > a')
  .forEach(l => l.hidden = true)

  links
  .forEach(l => {
    let anchors = document.querySelectorAll(`.${l.class}`)
    if (anchors.length) anchors.forEach(anchor => {
      anchor.hidden = false
      anchor.href = l.href 
    })
  })
}

async function buildRetailerLinks(isbn, type, productTitle) {
  if (!isbn) return 

  let contributor = $('.contributor-value').text()
  
  let googleLinks = [
    { 
      class: 'google-link',
      href: `https://play.google.com/store/search?q=${isbn}` 
    }
  ]

  let audioLinks = [
    { 
      class: 'audible-link',
      href: `https://www.amazon.ca/s?k=${productTitle}&i=audible` 
    },
    { 
      class: 'kobo-link', 
      href: `https://kobobooks.com/search/search.html?q=${isbn.replace('-', '')}`
    },
    { 
      class: 'librofm-link', 
      href: `https://libro.fm/audiobooks/${isbn}`
    }
  ]


  let retailerLinks = [
    { 
      class: 'shoplocal-link', 
      href: `https://shoplocal.bookmanager.com/isbn/${isbn}`
    },
    {
      class: 'amazon-ca-link',
      href: `https://www.amazon.ca/s?k=${isbn}`
    },
    {
      class: 'amazon-us-link',
      href: `https://www.amazon.com/s?k=${isbn}`
    },
    {
      class: 'indigo-link',
      href: await generateIndigoDeepLink(isbn, productTitle)
    },
    { 
      class: 'bookshop-link',
      href: `https://bookshop.org/books?keywords=${isbn}`
    }
  ]

  let digitalLinks = [
    
    { 
      class: 'amazon-kindle-link',
      href: `https://www.amazon.ca/s?k=${productTitle}+${contributor}&i=digital-text` 
    },
    { 
      class: 'ibooks-link',
      href: `https://itunes.apple.com/ca/book/isbn${isbn}`
    },
    { 
      class: 'kobo-link', 
      href: `https://kobobooks.com/search/search.html?q=${isbn}`
    }
  ]

  let epubLinks = [
    { 
      class: 'kobo-link', 
      href: `https://kobobooks.com/search/search.html?q=${isbn}`
    },
    { 
      class: 'ibooks-link',
      href: `https://itunes.apple.com/ca/book/isbn${isbn}`
    },
    
    { 
      class: 'amazon-kindle-link',
      href: `https://www.amazon.ca/s?k=${productTitle}+${contributor}&i=digital-text` 
    }
  ]

  let amazonLinks = [
    
    { 
      class: 'amazon-kindle-link',
      href: `https://www.amazon.ca/s?k=${productTitle}+${contributor}&i=digital-text` 
    }
  ]

  async function generateIndigoDeepLink(isbn, productTitle) {
    
    const api_key = "key_Al6HhP1ovMAKoxK5";
    
    
    const api_url = `https://ac.cnstrc.com/autocomplete/${isbn}?key=${api_key}`;

    try {
      
      const response = await fetch(api_url, {
          method: 'GET',
          headers: {
              'Accept': 'application/json'
          }
      });
      
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      
      const data = await response.json();
      
      
      const url = data?.sections?.Products?.[0]?.data?.url;
      
      return url || `https://www.indigo.ca/search?q=${isbn}`;

    } catch (error) {
      console.error("Failed to fetch data:", error);
      return null;
    }
  }

  updateRetailersNote()

  switch (type) {
    case 'epubs':
      return populateLinks(epubLinks)
    case 'amazon-only':
      return populateLinks(amazonLinks)
    case 'digital':
      return populateLinks(digitalLinks)
    case 'web-pdf':
      return populateLinks(googleLinks)
    case 'audio':
      updateRetailersNote('audio')
      return populateLinks(audioLinks)
    default:
      return populateLinks(retailerLinks)
  }
}

function updateRetailersNote(type) {
  let note = document.querySelector('.retailers-note')
  if (!note) return

  if (type == 'audio') {
    note.textContent = `
      To obtain this audiobook, 
      visit one of the audiobook retailers linked below
    `
    return
  }

  note.textContent = `
    To obtain this ebook, 
    visit one of the ebook retailers linked below
  `
}

function hideDropdown() {
  let activeVariant = document.querySelector('.active-variant')
  activeVariant.setAttribute('aria-expanded', false)

  let dropdowns = document.querySelectorAll('.nav-dropdown-custom')
  dropdowns.forEach(el => {
    el.classList.remove('active')
  })
}

const AT_Main = {
   getWidthBrowser: () => window.innerWidth,

  activateVariantDropdown(context, callback) {
    if (callback) callback() 

    if (context == '#product-wishlist') {
      Array.from($(`${context} .nav-dropdown-custom`))
			.forEach(menu => {
				orderByType($(menu))
				selectFirst($(menu))
			})
    } else if (context == '#quick-shop-popup') {
      let submenu = $('#quick-shop-popup')
      orderByType(submenu)
      selectFirst(submenu)
    } else {
      orderByType()
      selectFirst()
    }

    context = $(context || document)

    context.find('.active-variant').click(toggleActive)
    context.find('.active-variant').on('keypress', function(e) {
      e.which == 13 && toggleActive.call(this, e)
    })

    context.find('.nav-dropdown-custom li').each(function() {
      jQuery(this).click(handleDropdownClick)
      jQuery(this).on('keypress', function(e) {
        e.which == 13 && handleDropdownClick.call(this)
      })
    })

    window.addEventListener('click', handleOutsideClick(context))
  },

  checkLayout : function() { // Function to check level of layout
    if(jQuery("#checkLayout .visible-xs-block").css("display") == "block")
      return 1; //mobile layout
    else if(jQuery("#checkLayout .visible-sm-block").css("display") == "block")
      return 2; //tablet potrait layout
    else if(jQuery("#checkLayout .visible-md-block").css("display") == "block")
      return 3; //tablet landscape/medium desktop layout
    else if(jQuery("#checkLayout .visible-lg-block").css("display") == "block")
      return 4; //desktop layout
  },

  homeSlideshow() {
    if(!jQuery('.home-slideshow-wrapper').length) return

    jQuery('.home-slideshow-wrapper').each(function(index,value){
      var _delay_time = '';
      if(jQuery(value).data('autoplay')){
        _delay_time = jQuery(value).data('time');
      }

      var swiper = new Swiper('.swiper-container', {
        autoplay: _delay_time,
        loop: true,
        pagination: '.swiper-pagination',
        paginationClickable: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 30,
        scrollbarDraggable: true,
        effect: jQuery(value).data('animation'),
        setWrapperSize: false,
        onImagesReady: function(swiper){
          var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
              slideW = $(swiper.container[0]).find('.swiper-slide > img').width();

          $(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
          $(swiper.container[0]).find('.swiper-slide').each(function(){
            var that = $(this);
            that.find('.video-slide').show();
            that.find('.video-slide video').css({
              left: '50%',
              top: '50%',
              transform: 'translate(-50%,-50%)'
            });
          });
        }
      });
    });
  },

  homeIE() {
    if (!jQuery('.home-slideshow-wrapper').length) return

    jQuery('.home-slideshow-wrapper').each(function(index,value){
      var _delay_time = '';
      if(jQuery(value).data('autoplay')){
        _delay_time = jQuery(value).data('time');
      }

      var swiper = new Swiper('.swiper-container', {
          autoplay: _delay_time
          ,loop: true
          ,pagination: '.swiper-pagination'
          ,paginationClickable: '.swiper-pagination'
          ,nextButton: '.swiper-button-next'
          ,prevButton: '.swiper-button-prev'
          ,spaceBetween: 30
          ,scrollbarDraggable: true
          ,effect: 'fade'
          ,setWrapperSize: true
          ,onImagesReady: function(swiper){
            var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
                slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
              $(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
              $(swiper.container[0]).find('.swiper-slide').each(function(){
                var _this = $(this);
                _this.find('.video-slide').show();
                _this.find('.video-slide video').css({
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%,-50%)'
                });

              });
          }
      });
    });
  },

  stickMenu() {
    var enable_stick = jQuery(".header-content").data('stick');
    if(enable_stick){
      //Keep track of last scroll
      var lastScroll = 0;
      var header = jQuery(".horizontal-menu-wrapper");
      var body_content = jQuery("#body-content");

      jQuery(window).scroll(function() {
        //Sets the current scroll position
        var st = jQuery(this).scrollTop();
        //Determines up-or-down scrolling
        if (st > lastScroll) {

          //Replace this with your function call for downward-scrolling
          if (st > 250 ) {
            header.addClass("header-fixed fadeInDown animated");
            body_content.addClass("has-header-fixed");
          }
        }
        else {
          //Replace this with your function call for upward-scrolling
          if (st < 250) {
            header.removeClass("header-fixed fadeInDown animated");
            body_content.removeClass("has-header-fixed");
          }
        }
        //Updates scroll position
        lastScroll = st;
      });
    }

  }

  ,toTopButton : function(){
    var to_top_btn = $("#scroll-to-top");
    if( 1 > to_top_btn.length ){
      return;
    }
    $(window).on( 'scroll' , function() {
      var b = jQuery(this).scrollTop();
      var c = jQuery(this).height();
      if (b > 100) {
        var d = b + c / 2;
      }
      else {
        var d = 1 ;
      }

      if (d < 1000 && d < c) {
        jQuery("#scroll-to-top").removeClass('on off').addClass('off');
      } else {
        jQuery("#scroll-to-top").removeClass('on off').addClass('on');
      }
    });

    to_top_btn.on( 'click',function (e) {
      e.preventDefault();
      jQuery('body,html').animate({scrollTop:0},800,'swing');
    });
  }

  ,mailchipPopup : function(){
    var expire = jQuery("#mailchimp-popup").data('expires');
    if (jQuery.cookie('mycookie')) {
      //it hasn't been one days yet
    }
    else {
      jQuery.fancybox(
        jQuery('#mailchimp-popup'),
        {
          'autoDimensions': false
          ,'width'    : 760
          ,'height'    : 450
          ,'autoSize'   : false
          ,'transitionIn'  : 'none'
          ,'transitionOut': 'none'

        }
      );
    }
    jQuery.cookie('mycookie', 'true', { expires: expire });
  }

    ,toggleCartSidebar : function(){
    jQuery('.cart-toggle').on('click',function (e) {
      e.stopPropagation();
      AT_Main.fixNoScroll();
      jQuery('.cart-sb').toggleClass('opened');
      jQuery('body').toggleClass('cart-opened');
    });

    jQuery('#page-body').on('click',function () {
      jQuery('.cart-sb').removeClass('opened');
      jQuery('html,body').removeClass('cart-opened');
      AT_Main.fixReturnScroll();
    });
  }

    ,handleGridList : function(){
        jQuery(document).on('click','.grid-list span',function(){
            if(!$(this).hasClass('active')){
              $('.grid-list span').removeClass('active');
              $(this).addClass('active');

              if($(this).hasClass('grid')){
                window.sessionStorage.setItem('catalogue-view', 'grid')
                $('.cata-product').removeClass('cp-list');
                $('.product-price-range').removeClass('product-list-item');
                $('.cata-product').addClass('cp-grid');
                $('.product-price-range').addClass('product-grid-item');
              }
              else {
                window.sessionStorage.setItem('catalogue-view', 'list')
                $('.cata-product').addClass('cp-list');
                $('.product-price-range').addClass('product-list-item');
                $('.cata-product').removeClass('cp-grid');
                $('.product-price-range').removeClass('product-grid-item');
              }
            }
        });
    }

    ,effectNavigation : function(){ // Make hover effect of navigation
    jQuery(".horizontal-menu .navigation .navbar-collapse .main-nav>li").hover(function(e){
      jQuery(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').addClass("fadeInUp animated");
    },function(e){
      jQuery(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass("fadeInUp animated");
    });

        jQuery(".top-account-holder").hover(function(e){
      jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
    },function(e){
      jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
    });

        jQuery(".currency-block").hover(function(e){
      jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
    },function(e){
      jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
    });

  }

  ,fixNoScroll : function() { // Fixed persitent position of page when scroll disapear
    var windowW = jQuery(window).width();
    jQuery('#page-body, .header-content, #page-body .mobile-version').css("width", windowW + 'px');
  }

  ,fixReturnScroll : function() {
    jQuery('#page-body, .header-content,#page-body .mobile-version').attr('style', '');
  }

    ,fixButton : function(){
        jQuery(".product-wrapper .product-head").each(function(e){
            if($(this).children().hasClass('wrapper-countdown')){
                $(this).find('.product-button').addClass('fix');
            }
      });
    }

    ,handleReviews: function() {
        SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
    }

  ,menuOnMobile : function(){
    jQuery('#page-body').on('click',function () {
      jQuery(".menu-mobile").removeClass("opened");
      jQuery("html,body").removeClass("menu-opened");
      AT_Main.fixReturnScroll();
    });

    $('.is-mobile-nav a').click(e => {
      console.log(e)
      if (!e.currentTarget.classList.contains('dropdown-link')) 
        return

      e.preventDefault()

      console.log(e)
      console.log(e.target)

      let menu = $(e.target).parents('.dropdown').first()
      if (menu.hasClass("menu-mobile-open")) {
        menu.removeClass("menu-mobile-open")
        // also close all children dropdowns
        menu.find('.dropdown').removeClass('menu-mobile-open')
      } else {
          menu.addClass("menu-mobile-open")
      }
    })

    jQuery(document).on('click','[data-toggle=offcanvas]',function(e){
      e.stopPropagation();
      AT_Main.fixNoScroll();
      jQuery(".menu-mobile").toggleClass("opened");
      jQuery("html,body").toggleClass("menu-opened")
    });

    jQuery(".navbar .main-nav li").hover(function(){jQuery(this).addClass("hover")},function(){jQuery(this).removeClass("hover")});

    jQuery(".navbar .main-nav li").focus(function(){jQuery(this).addClass("hover")},function(){jQuery(this).removeClass("hover")});

  }

  ,handleMenuMultiLine : function() {
    var outItem = "";
    var down = false;

    var top = 0;

    jQuery(".navbar-collapse .main-nav > li").on("mousemove", function(e){
      var target = jQuery(e.currentTarget);

      if( down && outItem != "") {
        outItem.addClass("hold");
        setTimeout(function(){
          if(outItem != "")
          outItem.removeClass("hold");
          down = false;
          outItem = "";
        },500);

        if( (outItem[0] == target[0]) || (outItem.offset().top == target.offset().top) )
        {
          outItem.removeClass("hold");
          down = false;
          outItem = "";
        }
      }
      else {
        outItem = "";
      }

    });

    jQuery(".navbar-collapse .main-nav >li").on("mouseout", function(e){

      var target = jQuery(e.currentTarget);

      if( e.pageY >= target.offset().top + 50 ) { //move down
        down = true;
      }

      if( target.hasClass("dropdown") ) { //target has child

        if(outItem == "")
          outItem = target;
      }

    });
  }

    ,parallaxIt : function() {
    if($(".templateIndex").length == 0)
      return;
    $.fn.parallaxScroll = function(xpos, speedFactor, outerHeight) {
      var elem = $(this);
      var getHeight;
      var firstTop;
      var paddingTop = 0;

      //get the starting position of each element to have parallax applied to it
      $(this).each(function(){
        firstTop = $(this).offset().top;
      });

      getHeight = function(jqo) {
        return jqo.outerHeight(true);
      };

      var j$element, top, height, pos;

      function update(){

        pos = $(window).scrollTop();
        firstTop = elem.offset().top;
        height = getHeight(elem);

        if (pos + $(window).height() < firstTop || pos > firstTop + height) {
          return;
        }
        //j$this.find('.parallax_bg').transition({ 'y':  Math.round((firstTop - pos) * speedFactor) + "px"},0);

        if(AT_Main.checkLayout()!=1)
          elem.css('backgroundPosition', xpos + " " + Math.round((firstTop - pos) * speedFactor) + "px",0);
        else
          elem.css('backgroundPosition', xpos + " " + -Math.round((firstTop - pos) * speedFactor) + "px",0);
      }

      window.addEventListener('scroll', function(){
        update();
      }, false)

      update();
    };

    $(".parallax-section").parallaxScroll("50%",0.1);
  }

    ,callPriceSlider: function() {
      if( $('#range-slider').length <= 0 ){
        return;
      }

        var _min_price = jQuery('#amount > span.min-val > span.money').html() || '0.00'
          ,_min_price =_min_price.replace(/[^0-9\.]+/g,"")
            ,_min_price = _min_price.match(/\d+(\.\d+)?/g,"")
            ,_max_price = jQuery('#amount > span.max-val > span.money').html() || '0.00'
            ,_max_price =_max_price.replace(/[^0-9\.]+/g,"")
            ,_max_price = _max_price.match(/\d+(\.\d+)?/g,"");

        if( _min_price.length <= 0 || _max_price <= 0 ){
          return;
        }else{
           _min_price = Number(_min_price[0]);
           _max_price = Number(_max_price[0]);
        }

        $('#range-slider').slider({
            range: true,
            min: _min_price,
            max: _max_price,
            values: [_min_price, _max_price],
            create: function() {
              //Currency.convertAll('USD', Currency.currentCurrency);
              // $("#amount").html('<span class="min-val"><span class="money">$10.00</span></span> - <span class="max-val"><span class="money">30000.00</span></span>');
            },
            slide: function (event, ui) {
              $("#amount").html('<span class="min-val">' + Shopify.formatMoney(ui.values[0]*100,_bc_config.money_format) + '</span> - <span class="max-val">' + Shopify.formatMoney(ui.values[1]*100,_bc_config.money_format) + '</span>');
              Currency.convertAll('CAD' , Currency.currentCurrency);
              var mi = ui.values[0];
              var mx = ui.values[1];
              filterSystem(mi, mx);
            }
        })


        function filterSystem(minPrice, maxPrice) {
          $(".cata-product .product-price-range").hide().filter(function () {
            var price = parseInt($(this).data("price"), 10);
            return price >= minPrice && price <= maxPrice;
          }).show();
        }

    }

  ,fixTitle : function(){ // fix title a in filter
    jQuery(".rt a").attr("data-title", function() { return jQuery(this).attr("title"); });
    jQuery(".rt a").removeAttr("title");
  }

  ,filterCatalogReplace : function(){
    var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);
    var val = value.substring(value.lastIndexOf('?'));

    collectionUrl = collectionUrl.replace(value, '');

    value = value.replace(val, '');
    value = value.replace('#', '');

    var value_arr = value.split('+');

    var current_arr = [];
    jQuery('#'+filter_id+' li.active-filter').each( function() {
      current_arr.push(jQuery(this).attr('data-handle'));
    });

    jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
    jQuery('#'+filter_id+' li').removeClass('active-filter');

    for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
      value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
    }

    var new_data = value_arr.join('+')

    var new_url = collectionUrl+new_data+val;

    window.location = new_url;
  }

  ,filterCatalog : function(){
    var currentTags = ''
      ,filters   = jQuery('.advanced-filter');

    filters.each(function() {
      var el = jQuery(this)
        ,group = el.data('group');

      if ( el.hasClass('active-filter') ) { //Remove class hidden
        el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden');
      }
    });

    filters.on('click', function() {
      var el     = jQuery(this)
        ,group   = el.data('group')
        ,url   = el.find('a').attr('href');

      // Continue as normal if we're clicking on the active link
      if ( el.hasClass('active-filter') ) {
        return;
      }
    });

    jQuery('.sb-filter').on('click', '.clear-filter', function(n){ // Handle button clear

      var filter_id = jQuery(this).attr('id');
      filter_id = filter_id.replace('clear-', '');

      var collectionUrl = window.location.href;

      if(collectionUrl.match(/\?/)){
        var string = collectionUrl.substring(collectionUrl.lastIndexOf('?') - 1);

        if(string.match(/\//)){
          var str_replace = string.replace(/\//, '');
          collectionUrl = collectionUrl.replace(string, '');
          collectionUrl = collectionUrl+str_replace;
          AT_Main.filterCatalogReplace();
        }
        else{
          AT_Main.filterCatalogReplace();
        }
      }
      else{
        var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);

        collectionUrl = collectionUrl.replace(value, '');

        value = value.replace('#', '');

        var value_arr = value.split('+');

        var current_arr = [];
        jQuery('#'+filter_id+' li.active-filter').each( function() {
          current_arr.push(jQuery(this).attr('data-handle'));
        });

        jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
        jQuery('#'+filter_id+' li').removeClass('active-filter');

        for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
          value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
        }

        var new_data = value_arr.join('+')

        var new_url = collectionUrl+new_data;

        window.location = new_url;
      }

    });
  }

  ,swatch : function(){
        jQuery('.swatch :radio').change(function() {
            var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
            var optionValue = jQuery(this).val();
            jQuery(this)
            .closest('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
        });
    }

  ,refreshImage : function(){ // Update product image in detail page
    if(jQuery('#gallery-image').length){

      jQuery('#product-image').on('click', '.thumb-img', function() {

        var _$this = jQuery(this);

        if(!_$this.hasClass('active')){
          var parent = _$this.parents('.product-image-inner');
          var src_original = _$this.attr('data-zoom-image');
          var src_display = _$this.attr('data-image');
		  var featured_alt_text = parent.find('.featured-image').find('img').attr('alt');
		  var thumb_alt_text = _$this.find('img').attr('alt');

		  parent.find('.thumb-img.active.hidden').find('img').attr('alt', featured_alt_text);
		  parent.find('.thumb-img').removeClass('active');
          parent.find('.thumb-img').removeClass('hidden');
          _$this.addClass('active');
          _$this.addClass('hidden');

          parent.find('.featured-image').find('img').attr('data-zoom-image', src_original);
          parent.find('.featured-image').find('img').attr('src', src_display);
          parent.find('.featured-image').find('img').attr('alt', thumb_alt_text);
          parent.find('.featured-image').attr('href', src_original);
        } 

        return false;
      });
    }
  } 

  ,refreshZoom : function(){ // Update Zoom in detail page
    return  // no-op
  }

    ,scareName : function(){
        var _name_height = 0;
        jQuery('.product-wrapper').find('h5.product-name').each(function( index,value ){
          _name_height = jQuery(value).height() > _name_height ? jQuery(value).height() : _name_height;
        });
        jQuery('.product-wrapper').find('h5.product-name').css('height',_name_height);
    }
    ,scareScreen : function(){
        if( typeof _bc_config == "undefined" ){
            return;
        }
        var _current = this;

        if( _bc_config.enable_title_blance == "true" ){
            this.scareName();
        }

        jQuery( document ).ajaxComplete(function( event,request, settings ) {
          if( _bc_config.enable_title_blance == "true" ){
              _current.scareName();
          }
        });
    }

  ,cartJS_handle : function() {
	//Add custom rivetsJS formatter for multiplication
    rivets.formatters['*'] = function(value, args)
    {
      return value * args;
    };
    //Bind cart json data to HTML
    rivets.bind(jQuery('.templateCart #cartform, .cart-right, .page-cart .cart-empty-wrapper, #cart-content'), {cart: CartJS.cart});
    //It's need to calculate from default currency to current currency that has chosen before

          if( _bc_config.show_multiple_currencies == 'true' ){
            setTimeout(function(){
              Currency.convertAll('CAD' , Currency.currentCurrency);
            },50);
          }

    //Handle when update to cart json completed
    jQuery(document).on('cart.requestComplete', function(event, cart) {
      Shopify.onCartUpdate(CartJS.cart);
            if( _bc_config.show_multiple_currencies == 'true' ){
        Currency.convertAll('CAD' , Currency.currentCurrency);
            }
    });
  }

  ,init : function(){

        if( typeof _bc_config == 'undefined' ){
              console.log( " _bc_config is undefined " );
              return ;
        }

        this.stickMenu();
    this.toTopButton();
    this.mailchipPopup();
        this.toggleCartSidebar();
        this.handleGridList();
        this.effectNavigation();
        this.fixButton();
    this.menuOnMobile();
    this.handleMenuMultiLine();
    this.fixTitle();
    this.filterCatalog();
        this.swatch();
    this.refreshImage();
    this.refreshZoom();
    this.cartJS_handle();
  }
}


/* Handle when window resize */
jQuery(window).resize(function() {

  /* reset menu with condition */
  if(AT_Main.getWidthBrowser() < 1024){
    if(jQuery('#top').hasClass('on')){
      jQuery('#top').prev().remove();
      jQuery('#top').removeClass('on').removeClass('animated');
    }
  }

    /* Fakecrop */
    if(AT_Main.checkLayout() != 1){
        AT_Main.scareScreen();
    }

  /*Reset Page when fixNoScroll had called before*/
  AT_Main.fixReturnScroll();
  if(AT_Main.checkLayout() != 1 && jQuery('.menu-mobile').hasClass('opened'))
    jQuery("#page-body").trigger('click');

});

jQuery(document).ready(function($) {

  AT_Main.init();

    /* Fakecrop */
    if(AT_Main.checkLayout() != 1){
        AT_Main.scareScreen();
    }

});

(function(Resources, $, undefined) {
  var requestLimit = 50;
  var collections = [];
  var collectionsHandleMap = [];
  var products = [];
  var productsHandleMap = [];
  var tags = [];

  var getResources = function(resolve, reject) {

    var $getCollections = function(totalCollections) {
      var collectionDeferreds = [];
      for (var i = 0; i < totalCollections / requestLimit; i++) {
        var pageNumber = 1 + i;
        var $collectionRequest = $.get('/collections/all?view=list&page=' + pageNumber, function(response) {
          response = JSON.parse(response);
          $.merge(collections, response.collections);
        });
        collectionDeferreds.push($collectionRequest);
      }
      return $.when.apply($, collectionDeferreds).done(function() {
        collectionsHandleMap = $.map(collections, function(collection, index) {
          return collection.handle;
        });
      });
    };

    var $getProducts = function(totalProducts) {
      var productDeferreds = [];
      for (var i = 0; i < totalProducts / requestLimit; i++) {
        var pageNumber = 1 + i;
        let url = '/collections/all?view=products&page=' + pageNumber
        var $productRequest = $.get(url, function(response) {
          try {
            response = response.replace(/:\s,/g, `: "",`)
            response = JSON.parse(response);
            $.merge(products, response.products);
          } catch (error) {
            console.error("ERROR in page", url)
            console.error(error)
          }
        });
        productDeferreds.push($productRequest);
      }
      return $.when.apply($, productDeferreds).done(function() {
        productsHandleMap = $.map(products, function(product, index) {
          return product.handle;
        });
      });
    };

    var $getActive = $.get('/collections/all?view=endpoint', function(response) {
      response = JSON.parse(response);
      $.when($getCollections(response.totalCollections), $getProducts(response.totalProducts)).done(function() {
        $.each(products, function(index, product) {
          $.each(product.collections, function(index, collectionHandle) {
            collections[collectionsHandleMap.indexOf(collectionHandle)].products.push(product.handle)
          });
        });
        resolve(products)
      })
    });

  }

  Resources.retrieveProduct = function(handle) {
    return products[productsHandleMap.indexOf(handle)];
  };

  Resources.tags = function() {
    return new Set(products.map(p => p.tags).flat())
  }

  Resources.buildCollection = function(collectionHandle) {
    var builtCollection = [];
    var collection = collections[collectionsHandleMap.indexOf(collectionHandle)]
    $.each(collection.products, function(index, handle) {
      builtCollection.push(products[productsHandleMap.indexOf(handle)]);
    });
    return builtCollection;
  };


  Resources.init = () => new Promise(getResources)

  Resources.products = function() {
    return products
  }

  Resources.bios = function() {
    let bios = products.reduce((contributors, p) => {
      for (let i = 0; i <= 8; i++) {
        let contributor = p.metafields[`Contributor_${i}`]
        if (contributor) {
          let bio = p.metafields[`ContributorBio_${i}`]
          let photo = p.metafields[`ContributorPhoto_${i}`]
          contributors[contributor] = { bio, photo }

          if (photo) console.log(contributor)
        }
      }
      return contributors
    }, {})
    return bios
  }

}(window.Resources = window.Resources || {}, jQuery))

// Editor-specific code

const handleSectionLoad = e => {
  if (e.target.classList.contains('featured-product')) {
    AT_Main.activateVariantDropdown()
  }
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener(
    'shopify:section:load', 
    handleSectionLoad
  )
}

// Insert link to Education Central

document.addEventListener('DOMContentLoaded', function() {
  const linkContainer = document.getElementById('supporting-resources-links-container');

  if (linkContainer) {
    const bookTitle = linkContainer.getAttribute('data-book-handle');
    const bookUrl = `https://education-central.com/books/${bookTitle}`;

    fetch(bookUrl, { method: 'HEAD'})
      .then(response => {
        const rowElement = linkContainer.closest('.supporting-resources-row');
        if (response.ok) {
          const linkElement = document.createElement('a');
          linkElement.href = bookUrl;
          linkElement.textContent = "View on Education Central";
          linkElement.target = '_blank';
          linkElement.id = 'education-central-link';
          linkContainer.appendChild(linkElement);
          if (rowElement) {
            rowElement.classList.remove('hidden');
          }
        } else {
          console.log(`URL ${bookUrl} resulted in a ${response.status} status.`);
          linkContainer.classList.add('education-central-link-inactive');
          const hasResources = linkContainer.getAttribute('data-has-resources') === 'true';
          if (!hasResources && rowElement) {
            rowElement.classList.add('hidden');
          }
        }
      })
      .catch(error => {
        console.error('Error checking the book URL:', error);
        linkContainer.classList.add('education-central-link-inactive');
        const rowElement = linkContainer.closest('.supporting-resources-row');
        const hasResources = linkContainer.getAttribute('data-has-resources') === 'true';
        if (!hasResources && rowElement) {
          rowElement.classList.add('hidden');
        }
      });
  }
});